import { TournamentAwardsList as TournamentAwardsListComponent } from './TournamentAwardsList.component';
import { connector } from './TournamentAwardsList.connector';

export const TournamentAwardsList = connector(TournamentAwardsListComponent);
